/**
 * Detect if running inside IS24 native app webview
 */
export const getNativePlatform = (): 'ios' | 'android' | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('immoscout/ios')) {
    return 'ios';
  }
  if (userAgent.includes('immoscout/android')) {
    return 'android';
  }
  return null;
};
/**
 * True if inside native app
 */
export const isNativeWebView = (): boolean => {
  return getNativePlatform() !== null;
};
